// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/core/svc_report.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { AddToothDisplaySliceReq, AddToothDisplaySliceResp, ApproveAllTeethAndSignReportReq, ApproveAllTeethAndSignReportResp, ApproveReportToothReq, ApproveReportToothResp, ArchiveReportReq, ArchiveReportResp, CreateReportToothConditionsReq, CreateReportToothConditionsResp, DeleteReportReq, DeleteReportResp, DisapproveReportToothReq, DisapproveReportToothResp, GenerateSuggestedToothTreatmentReq, GenerateSuggestedToothTreatmentResp, GetReportsByStudyAssetAttributesReq, GetReportsByStudyAssetAttributesResp, MarkToothAsDeletedReq, MarkToothAsDeletedResp, MarkToothDetectionAsDeletedReq, MarkToothDetectionAsDeletedResp, PrintReportReq, PrintReportResp, RemoveAllToothDisplaySlicesReq, RemoveAllToothDisplaySlicesResp, RemoveToothDisplaySliceReq, RemoveToothDisplaySliceResp, ReportDataStreamReq, ReportDataStreamResp, RequestReportReq, RequestReportResp, ResetReportToothReq, ResetReportToothResp, RestoreReportReq, RestoreReportResp, RestoreToothDisplaySlicesReq, RestoreToothDisplaySlicesResp, SetImageMetaOrientationAngleReq, SetImageMetaOrientationAngleResp, SetImageMetaViewOptionsReq, SetImageMetaViewOptionsResp, SetReportConclusionReq, SetReportConclusionResp, SetReportExtendedConclusionReq, SetReportExtendedConclusionResp, SetReportMedicalImageViewOptionsReq, SetReportMedicalImageViewOptionsResp, SetReportPrintSettingsReq, SetReportPrintSettingsResp, SetReportSettingsReq, SetReportSettingsResp, SetReportToothCommentReq, SetReportToothCommentResp, SetReportToothConditionsUserDecisionReq, SetReportToothConditionsUserDecisionResp, SetReportToothConditionUserScoreAndApproveToothReq, SetReportToothConditionUserScoreAndApproveToothResp, SetROIReq, SetROIResp, SetToothDetectionNumerationAndReviveReq, SetToothDetectionNumerationAndReviveResp, SetToothFullHeadMPRSliceAnnotationsReq, SetToothFullHeadMPRSliceAnnotationsResp, SetToothFullHeadMPRSliceEditorStateReq, SetToothFullHeadMPRSliceEditorStateResp, SetToothFullHeadMPRSliceSelectionReq, SetToothFullHeadMPRSliceSelectionResp, SetToothFullHeadMPRSliceViewOptionsReq, SetToothFullHeadMPRSliceViewOptionsResp, SetToothMPRSliceOptionsReq, SetToothMPRSliceOptionsResp, SetToothNumerationAndReviveReq, SetToothNumerationAndReviveResp, SignReportReq, SignReportResp, UnsignReportReq, UnsignReportResp, UpdateTeethStateReq, UpdateTeethStateResp } from "./svc_report_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Common errors:
 * - type: RequiredArgumentMissingError, Argument: ReportID
 * - type: NotFoundError, Entity: report (if report not found by ReportID)
 * - type: BadRequestError, Reason: report/tooth deleted (if remote report/tooth found by ReportID)
 * - type: NotFoundError, Entity: tooth (if tooth not found by ToothID)
 *
 * @generated from service com.diagnocat.core.ReportService
 */
export const ReportService = {
  typeName: "com.diagnocat.core.ReportService",
  methods: {
    /**
     * @generated from rpc com.diagnocat.core.ReportService.ReportDataStream
     */
    reportDataStream: {
      name: "ReportDataStream",
      I: ReportDataStreamReq,
      O: ReportDataStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Request report
     *
     * Permission: `PatientPermissions.CanRequestReport`
     *
     * @generated from rpc com.diagnocat.core.ReportService.RequestReport
     */
    requestReport: {
      name: "RequestReport",
      I: RequestReportReq,
      O: RequestReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Get reports (ReportType_IOXRay_GP && ReportType_Pano_GP)
     * by Asset.Attributes (AssetType_Study_IntraoralXRay || AssetType_Study_PanoramicXRay)
     *
     * If the request contains several attributes,
     * then only reports (study_assets) with all mentioned attributes are returned
     *
     * Permission: `ReportPermissions.CanView`
     *
     * @generated from rpc com.diagnocat.core.ReportService.GetReportsByStudyAssetAttributes
     */
    getReportsByStudyAssetAttributes: {
      name: "GetReportsByStudyAssetAttributes",
      I: GetReportsByStudyAssetAttributesReq,
      O: GetReportsByStudyAssetAttributesResp,
      kind: MethodKind.Unary,
    },
    /**
     * Mark report as deleted using report id
     * - an active report and an archived one are both deletable
     * - deletion is final: the report cannot be brought back, and its display
     * image and Studio payload leave storage 30 days later
     *
     * Permission: `ReportPermissions.CanDelete`
     *
     * @generated from rpc com.diagnocat.core.ReportService.DeleteReport
     */
    deleteReport: {
      name: "DeleteReport",
      I: DeleteReportReq,
      O: DeleteReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Restore an archived report back to the active report list
     * - available only if the `Enable_ArchiveReports` organization feature flag is on
     * - only an archived report can be restored
     *
     * Permission: `ReportPermissions.CanRestore`
     *
     * @generated from rpc com.diagnocat.core.ReportService.RestoreReport
     */
    restoreReport: {
      name: "RestoreReport",
      I: RestoreReportReq,
      O: RestoreReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Archive report using report id
     * - available only if the `Enable_ArchiveReports` organization feature flag is on
     * - the report is moved out of the active report list and stays fully
     * readable; nothing is deleted and no storage cleanup is scheduled
     * - an archived report is brought back with `RestoreReport` or deleted for
     * good with `DeleteReport`
     *
     * Permission: `ReportPermissions.CanArchive`
     *
     * @generated from rpc com.diagnocat.core.ReportService.ArchiveReport
     */
    archiveReport: {
      name: "ArchiveReport",
      I: ArchiveReportReq,
      O: ArchiveReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set region of interest (slice of tooth identifiers) and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeROI`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetROI
     */
    setROI: {
      name: "SetROI",
      I: SetROIReq,
      O: SetROIResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set legacy conclusion and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeConclusion`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportConclusion
     */
    setReportConclusion: {
      name: "SetReportConclusion",
      I: SetReportConclusionReq,
      O: SetReportConclusionResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set extended conclusion and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeConclusion`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportExtendedConclusion
     */
    setReportExtendedConclusion: {
      name: "SetReportExtendedConclusion",
      I: SetReportExtendedConclusionReq,
      O: SetReportExtendedConclusionResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set report settings and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeSettings`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportSettings
     */
    setReportSettings: {
      name: "SetReportSettings",
      I: SetReportSettingsReq,
      O: SetReportSettingsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Permission: `ReportPermissions.CanChangeSettings`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportPrintSettings
     */
    setReportPrintSettings: {
      name: "SetReportPrintSettings",
      I: SetReportPrintSettingsReq,
      O: SetReportPrintSettingsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Sign report and turn off `ReportPrintSettings.ShowDiagnosesProbabilities`
     *
     * Permission: `ReportPermissions.CanSign`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SignReport
     */
    signReport: {
      name: "SignReport",
      I: SignReportReq,
      O: SignReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Remove all signatures from report
     *
     * Permission: `ReportPermissions.CanSign`
     *
     * @generated from rpc com.diagnocat.core.ReportService.UnsignReport
     */
    unsignReport: {
      name: "UnsignReport",
      I: UnsignReportReq,
      O: UnsignReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Permission: `ReportPermissions.CanChangeReportAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportMedicalImageViewOptions
     */
    setReportMedicalImageViewOptions: {
      name: "SetReportMedicalImageViewOptions",
      I: SetReportMedicalImageViewOptionsReq,
      O: SetReportMedicalImageViewOptionsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set viewOptions to Report_IOXRay_GP.Image_Meta || Report_Pano_GP.Image_Meta
     *
     * Permission: `ReportPermissions.CanChangeReportAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetImageMetaViewOptions
     */
    setImageMetaViewOptions: {
      name: "SetImageMetaViewOptions",
      I: SetImageMetaViewOptionsReq,
      O: SetImageMetaViewOptionsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set OrientationAngle to Report_IOXRay_GP.Image_Meta || Report_Pano_GP.Image_Meta || Report_Pano_Bitewings
     *
     * Permission: `ReportPermissions.CanChangeReportAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetImageMetaOrientationAngle
     */
    setImageMetaOrientationAngle: {
      name: "SetImageMetaOrientationAngle",
      I: SetImageMetaOrientationAngleReq,
      O: SetImageMetaOrientationAngleResp,
      kind: MethodKind.Unary,
    },
    /**
     * Generate and save a print of the report (e.g. surgical guide) while replacing the old one if exists.
     * Expected to be used for printing other report types like CBCT GP in the future.
     *
     * Permission: `ReportPermissions.CanChangeReportAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.PrintReport
     */
    printReport: {
      name: "PrintReport",
      I: PrintReportReq,
      O: PrintReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set the tooth's comment
     *
     * Permission: `ReportPermissions.CanChangeToothComment`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportToothComment
     */
    setReportToothComment: {
      name: "SetReportToothComment",
      I: SetReportToothCommentReq,
      O: SetReportToothCommentResp,
      kind: MethodKind.Unary,
    },
    /**
     * Queue the generation of an AI suggested treatment for the tooth. The result
     * is saved as a tooth's comment. Overwrites the existing comment. Set's
     * Tooth.SuggestedTreatmentStatus to IN_PROGRESS. Subsequent calls will return
     * a UserBadRequestError if the status is IN_PROGRESS. Disapproves the tooth and
     * un-signs the report.
     *
     * Permission: `ReportPermissions.CanChangeToothComment`
     *
     * @generated from rpc com.diagnocat.core.ReportService.GenerateSuggestedToothTreatment
     */
    generateSuggestedToothTreatment: {
      name: "GenerateSuggestedToothTreatment",
      I: GenerateSuggestedToothTreatmentReq,
      O: GenerateSuggestedToothTreatmentResp,
      kind: MethodKind.Unary,
    },
    /**
     * Batch update of teeth state: numeration changes and logical deletions.
     * Works strictly within a single Report (ReportID) context.
     * Supports both Tooth and ToothDetection targets belonging to that report.
     *
     * Actions performed:
     * - SetNumeration:
     * • If ToothID is set: change Tooth ISO number and SupernumeraryIndex,
     * disapprove the tooth, revive Tooth and all its ToothDetections (clear IsRemoved),
     * return Tooth to ROI, un-sign the report.
     * • If ToothDetectionID is set: reassign detection to the specified numeration (i.e. move
     * ToothDetection to another Tooth according to numeration), disapprove both source
     * and target Teeth, revive ToothDetection and both Teeth (clear IsRemoved as needed),
     * return both Teeth to ROI, un-sign the report.
     *
     * - MarkDeleted:
     * • If ToothID is set: set Tooth.IsRemoved, disapprove the Tooth, remove it from ROI,
     * un-sign the report.
     * • If ToothDetectionID is set: set ToothDetection.IsRemoved; if it was the last
     * detection of the tooth, set Tooth.IsRemoved as well. Disapprove the Tooth,
     * un-sign the report.
     *
     * Permission: `ReportPermissions.CanChangeToothNumeration`
     *
     * @generated from rpc com.diagnocat.core.ReportService.UpdateTeethState
     */
    updateTeethState: {
      name: "UpdateTeethState",
      I: UpdateTeethStateReq,
      O: UpdateTeethStateResp,
      kind: MethodKind.Unary,
    },
    /**
     * SetToothNumerationAndRevive: only if tooth has detections
     * - Change Tooth ISO number and SupernumeraryIndex
     * - Disapprove Tooth
     * - Revive Tooth and all ToothDetections (delete IsRemoved flags from Tooth and all ToothDetections)
     * - Return Tooth to ROI
     * - Un-sign report
     *
     * Permission: `ReportPermissions.CanChangeToothNumeration`
     *
     * ⚠️ Deprecated: use `UpdateTeethState` instead.
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetToothNumerationAndRevive
     * @deprecated
     */
    setToothNumerationAndRevive: {
      name: "SetToothNumerationAndRevive",
      I: SetToothNumerationAndReviveReq,
      O: SetToothNumerationAndReviveResp,
      kind: MethodKind.Unary,
    },
    /**
     * SetToothDetectionNumerationAndRevive:
     * - Change toothDetection ISO number and SupernumeraryIndex (replace to another Tooth)
     * - Disapprove source and target teeth
     * - Revive ToothDetection (delete IsRemoved flag from ToothDetection)
     * - Revive Tooth
     * - Return Tooth to ROI
     * - Un-sign Report
     *
     * Permission: `ReportPermissions.CanChangeToothNumeration`
     *
     * ⚠️ Deprecated: use `UpdateTeethState` instead.
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetToothDetectionNumerationAndRevive
     * @deprecated
     */
    setToothDetectionNumerationAndRevive: {
      name: "SetToothDetectionNumerationAndRevive",
      I: SetToothDetectionNumerationAndReviveReq,
      O: SetToothDetectionNumerationAndReviveResp,
      kind: MethodKind.Unary,
    },
    /**
     * MarkToothAsDeleted:
     * - Set IsRemoved flag on Tooth
     * - Disapprove Tooth
     * - Remove Tooth from ROI
     * - Un-sign Report
     *
     * Permission: `ReportPermissions.CanChangeToothNumeration`
     *
     * ⚠️ Deprecated: use `UpdateTeethState` instead.
     *
     * @generated from rpc com.diagnocat.core.ReportService.MarkToothAsDeleted
     * @deprecated
     */
    markToothAsDeleted: {
      name: "MarkToothAsDeleted",
      I: MarkToothAsDeletedReq,
      O: MarkToothAsDeletedResp,
      kind: MethodKind.Unary,
    },
    /**
     * MarkToothDetectionAsDeleted:
     * - Set IsRemoved flag on ToothDetection
     * - Set IsRemoved on Tooth, if this is the last ToothDetection being removed
     * - Disapprove Tooth
     * - Un-sign report
     *
     * Permission: `ReportPermissions.CanChangeToothNumeration`
     *
     * ⚠️ Deprecated: use `UpdateTeethState` instead.
     *
     * @generated from rpc com.diagnocat.core.ReportService.MarkToothDetectionAsDeleted
     * @deprecated
     */
    markToothDetectionAsDeleted: {
      name: "MarkToothDetectionAsDeleted",
      I: MarkToothDetectionAsDeletedReq,
      O: MarkToothDetectionAsDeletedResp,
      kind: MethodKind.Unary,
    },
    /**
     * Using this method doctor confirms that conditions on this tooth are correct
     *
     * Permission: `ReportPermissions.CanChangeToothApproved`
     *
     * @generated from rpc com.diagnocat.core.ReportService.ApproveReportTooth
     */
    approveReportTooth: {
      name: "ApproveReportTooth",
      I: ApproveReportToothReq,
      O: ApproveReportToothResp,
      kind: MethodKind.Unary,
    },
    /**
     * Disapprove tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeToothApproved`
     *
     * @generated from rpc com.diagnocat.core.ReportService.DisapproveReportTooth
     */
    disapproveReportTooth: {
      name: "DisapproveReportTooth",
      I: DisapproveReportToothReq,
      O: DisapproveReportToothResp,
      kind: MethodKind.Unary,
    },
    /**
     * Approve all disapprove teeth in ROI and sign report and turn off `ReportPrintSettings.ShowDiagnosesProbabilities`
     * Permission: `ReportPermissions.CanChangeToothApproved` && `ReportPermissions.CanSign`
     *
     * @generated from rpc com.diagnocat.core.ReportService.ApproveAllTeethAndSignReport
     */
    approveAllTeethAndSignReport: {
      name: "ApproveAllTeethAndSignReport",
      I: ApproveAllTeethAndSignReportReq,
      O: ApproveAllTeethAndSignReportResp,
      kind: MethodKind.Unary,
    },
    /**
     * Reset tooth && tooth conditions and un-sign report
     *
     * Permission: `ReportPermissions.CanResetTooth`
     *
     * @generated from rpc com.diagnocat.core.ReportService.ResetReportTooth
     */
    resetReportTooth: {
      name: "ResetReportTooth",
      I: ResetReportToothReq,
      O: ResetReportToothResp,
      kind: MethodKind.Unary,
    },
    /**
     * Add Asset to tooth displaySlices, disapprove tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeConditions`
     *
     * @generated from rpc com.diagnocat.core.ReportService.AddToothDisplaySlice
     */
    addToothDisplaySlice: {
      name: "AddToothDisplaySlice",
      I: AddToothDisplaySliceReq,
      O: AddToothDisplaySliceResp,
      kind: MethodKind.Unary,
    },
    /**
     * Remove Asset from tooth displaySlices, disapprove tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeToothAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.RemoveToothDisplaySlice
     */
    removeToothDisplaySlice: {
      name: "RemoveToothDisplaySlice",
      I: RemoveToothDisplaySliceReq,
      O: RemoveToothDisplaySliceResp,
      kind: MethodKind.Unary,
    },
    /**
     * Remove all assets from tooth displaySlices, disapprove tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeToothAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.RemoveAllToothDisplaySlices
     */
    removeAllToothDisplaySlices: {
      name: "RemoveAllToothDisplaySlices",
      I: RemoveAllToothDisplaySlicesReq,
      O: RemoveAllToothDisplaySlicesResp,
      kind: MethodKind.Unary,
    },
    /**
     * Restore default tooth displaySlices, disapprove tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeToothAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.RestoreToothDisplaySlices
     */
    restoreToothDisplaySlices: {
      name: "RestoreToothDisplaySlices",
      I: RestoreToothDisplaySlicesReq,
      O: RestoreToothDisplaySlicesResp,
      kind: MethodKind.Unary,
    },
    /**
     * Replace the tooth's full-head MPR slice options (per-orientation slab thickness
     * and slice step), disapprove tooth and un-sign report. Changing an orientation's
     * step switches to that step's series records, retaining other steps' selections,
     * annotations and image adjustments. Responses expose only the active step of each
     * orientation, alongside independently saved views.
     * Changing only thickness preserves every series record and its annotation raster.
     * The displayed slab uses the current series options. Stored editor display recipes
     * provide the crop and window; their sampling is resolved from those options when
     * rendering, including before the next editor save.
     * Saved-view records keep their independent sampling under either options change.
     * A request whose options equal the stored ones (or the defaults, whether stored
     * or not) is a no-op: it neither un-signs the report nor disapproves the tooth and
     * does not grow the revision; the tooth's empty full-head MPR container may still
     * be created by the first call.
     *
     * Slab value constraints and defaults are documented on ToothMPRSliceOptions.
     *
     * Requires the `Enable_FullHeadMPRs` feature flag. CBCT GP reports only.
     *
     * Permission: `ReportPermissions.CanChangeToothAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetToothMPRSliceOptions
     */
    setToothMPRSliceOptions: {
      name: "SetToothMPRSliceOptions",
      I: SetToothMPRSliceOptionsReq,
      O: SetToothMPRSliceOptionsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Add or remove a client-generated full-head MPR slice to/from the report,
     * disapprove tooth and un-sign report. This is the only RPC that writes the
     * record's Selection (Added/Removed): a Removed record persists the removal of
     * a default-selected slice. Records survive slice-step changes until a tooth reset
     * or until the oldest inactive step history is evicted at the total-records cap.
     *
     * Requires the `Enable_FullHeadMPRs` feature flag. CBCT GP reports only.
     *
     * Permission: `ReportPermissions.CanChangeToothAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetToothFullHeadMPRSliceSelection
     */
    setToothFullHeadMPRSliceSelection: {
      name: "SetToothFullHeadMPRSliceSelection",
      I: SetToothFullHeadMPRSliceSelectionReq,
      O: SetToothFullHeadMPRSliceSelectionResp,
      kind: MethodKind.Unary,
    },
    /**
     * Replace the annotations of a client-generated full-head MPR slice, disapprove
     * tooth and un-sign report. Works for slices not added to the report: the slice
     * record is created on first write (Geometry is required in that case) and carries
     * Selection=Default — annotating never changes which slices are in the report.
     * An empty annotation list for a record that does not exist yet is a no-op: no
     * slice record is created and the revision does not grow; the tooth's empty
     * full-head MPR container may still be created by the first call.
     * Guide annotations are not accepted.
     *
     * Requires the `Enable_FullHeadMPRs` feature flag. CBCT GP reports only.
     *
     * Permission: `ReportPermissions.CanChangeToothAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetToothFullHeadMPRSliceAnnotations
     */
    setToothFullHeadMPRSliceAnnotations: {
      name: "SetToothFullHeadMPRSliceAnnotations",
      I: SetToothFullHeadMPRSliceAnnotationsReq,
      O: SetToothFullHeadMPRSliceAnnotationsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Merge the view options (brightness/contrast/sharpness) of a client-generated
     * full-head MPR slice: a field absent from the message keeps its stored value.
     * Quiet like AssetService.SetMedicalImageViewOptions: does NOT disapprove the tooth
     * and does NOT un-sign the report. Works for slices not added to the report: the
     * slice record is created on first write (Geometry is required in that case) and
     * carries Selection=Default. A request whose every non-empty field equals the
     * current value (or is zero while nothing is stored) changes nothing: no record is
     * created and the revision does not grow; the tooth's empty full-head MPR container
     * may still be created by the first call. The request has no selection field at
     * all, so this quiet call can never change the report's composition — that
     * requires the loud SetToothFullHeadMPRSliceSelection.
     *
     * Requires the `Enable_FullHeadMPRs` feature flag. CBCT GP reports only.
     *
     * Permission: `ReportPermissions.CanChangeReportAssets`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetToothFullHeadMPRSliceViewOptions
     */
    setToothFullHeadMPRSliceViewOptions: {
      name: "SetToothFullHeadMPRSliceViewOptions",
      I: SetToothFullHeadMPRSliceViewOptionsReq,
      O: SetToothFullHeadMPRSliceViewOptionsResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.ReportService.SetToothFullHeadMPRSliceEditorState
     */
    setToothFullHeadMPRSliceEditorState: {
      name: "SetToothFullHeadMPRSliceEditorState",
      I: SetToothFullHeadMPRSliceEditorStateReq,
      O: SetToothFullHeadMPRSliceEditorStateResp,
      kind: MethodKind.Unary,
    },
    /**
     * Create new condition, disapprove tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeConditions`
     *
     * Errors:
     * - type: BadRequestError, Reason: ROI does not contain this tooth
     *
     * @generated from rpc com.diagnocat.core.ReportService.CreateReportToothConditions
     */
    createReportToothConditions: {
      name: "CreateReportToothConditions",
      I: CreateReportToothConditionsReq,
      O: CreateReportToothConditionsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set user decision for conditions bound to one tooth, disapprove tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeConditions`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportToothConditionsUserDecision
     */
    setReportToothConditionsUserDecision: {
      name: "SetReportToothConditionsUserDecision",
      I: SetReportToothConditionsUserDecisionReq,
      O: SetReportToothConditionsUserDecisionResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set user score for tooth condition, approve tooth and un-sign report
     *
     * Permission: `ReportPermissions.CanChangeConditions`
     *
     * @generated from rpc com.diagnocat.core.ReportService.SetReportToothConditionUserScoreAndApproveTooth
     */
    setReportToothConditionUserScoreAndApproveTooth: {
      name: "SetReportToothConditionUserScoreAndApproveTooth",
      I: SetReportToothConditionUserScoreAndApproveToothReq,
      O: SetReportToothConditionUserScoreAndApproveToothResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

